import { InjectionToken, type Signal, signal } from '@angular/core';
import { AG_APPLICATIONS, type RoleEntityPermissionMap } from '@ag-common-lib/public-api';
import { of, type Observable } from 'rxjs';
import type { ReportsSectionId } from '../../utils/report-sections.utils';

/**
 * What an app supplies to the shared reports viewer and its dashboards.
 *
 * The shared code knows neither app's permission system: the app says which report sections
 * this viewer sees and hands over their permission map, and tiles and dashboards check the
 * entity each one needs against it.
 */
export type ProductionDashboardContext = {
  viewedAgentSig: Signal<any>;
  paidFileAsOfData$: Observable<Date | string | null | undefined>;
  years$: Observable<number[]>;
  myReportsRouteCommands: any[];
  platform: AG_APPLICATIONS;
  /** The report sections this app shows to the current viewer. */
  visibleSectionsSig: Signal<ReadonlySet<ReportsSectionId>>;
  /** The viewer's permissions; a tile or dashboard shows only if they hold its entity. */
  permissionsSig: Signal<RoleEntityPermissionMap | null>;
  /** Whether the viewer may edit report default settings (the gear on report tiles). */
  canManageDefaultsSig: Signal<boolean>;
};

export const PRODUCTION_DASHBOARD_CONTEXT = new InjectionToken<ProductionDashboardContext>(
  'PRODUCTION_DASHBOARD_CONTEXT',
  {
    providedIn: 'root',
    factory: () => ({
      viewedAgentSig: signal(null),
      paidFileAsOfData$: of(null),
      years$: of([]),
      myReportsRouteCommands: ['/reports-viewer'],
      platform: AG_APPLICATIONS.ARM,
      visibleSectionsSig: signal(new Set<ReportsSectionId>()),
      permissionsSig: signal(null),
      canManageDefaultsSig: signal(false),
    }),
  },
);
